"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parentingAndSubstanceAbuseMythOrFactProblems = void 0;
exports.parentingAndSubstanceAbuseMythOrFactProblems = [
    {
        id: "problem-1",
        statement: "Substance use impacts people despite their socioeconomic status or backgrounds.",
        correct: "fact",
        feedback: " This is a fact. Many people believe that substance abuse is only a problem in low-income populations. But actually, substance abuse affects people from every income level.",
    },
    {
        id: "problem-2",
        statement: "The effects of substances can have a long-term impact on people’s brain and body function.",
        correct: "fact",
        feedback: "This is a fact. The changes caused by substance use can alter people’s brain function and body sensations for a long period of time.",
    },
    {
        id: "problem-3",
        statement: 'Prescription opioids are safer than "street drugs" because physicians prescribe them all the time.',
        correct: "myth",
        feedback: 'This is a myth. "Street drugs" and prescription opioids frequently have the exact same addictive properties and some prescription drugs can even be worse.',
    },
    {
        id: "problem-4",
        statement: "Binge drinking is defined as more than 10 drinks in one night.",
        correct: "myth",
        feedback: "This is a myth. Actually, binge drinking is defined as consuming a great amount of alcohol in a short period of time. In a two-hour period, if a woman has four or more drinks, or a man has five or more drinks, they are binge drinking.",
    },
    {
        id: "problem-5",
        statement: " Most people use marijuana at least a couple times a week.",
        correct: "myth",
        feedback: "This is a myth. The numbers are actually much smaller: About 22% for people aged 18-25 years, and only 9% of people older than 25 years used marijuana in the past month.",
    },
    {
        id: "problem-6",
        statement: "After people have children, their use of substances tends to go down?",
        correct: "fact",
        feedback: "This is a fact.",
    },
];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGFyZW50aW5nQW5kU3Vic3RhbmNlQWJ1c2VNeXRoT3JGYWN0UHJvYmxlbXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvY29uc3RhbnRzL3BhcmVudGluZ0FuZFN1YnN0YW5jZUFidXNlTXl0aE9yRmFjdFByb2JsZW1zLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsNENBQTRDLEdBQXdCO0lBQy9FO1FBQ0UsRUFBRSxFQUFFLFdBQVc7UUFDZixTQUFTLEVBQ1AsaUZBQWlGO1FBQ25GLE9BQU8sRUFBRSxNQUFNO1FBQ2YsUUFBUSxFQUNOLDhLQUE4SztLQUNqTDtJQUNEO1FBQ0UsRUFBRSxFQUFFLFdBQVc7UUFDZixTQUFTLEVBQ1AsNEZBQTRGO1FBQzlGLE9BQU8sRUFBRSxNQUFNO1FBQ2YsUUFBUSxFQUNOLHNJQUFzSTtLQUN6STtJQUNEO1FBQ0UsRUFBRSxFQUFFLFdBQVc7UUFDZixTQUFTLEVBQ1Asb0dBQW9HO1FBQ3RHLE9BQU8sRUFBRSxNQUFNO1FBQ2YsUUFBUSxFQUNOLDRKQUE0SjtLQUMvSjtJQUNEO1FBQ0UsRUFBRSxFQUFFLFdBQVc7UUFDZixTQUFTLEVBQUUsZ0VBQWdFO1FBQzNFLE9BQU8sRUFBRSxNQUFNO1FBQ2YsUUFBUSxFQUNOLDRPQUE0TztLQUMvTztJQUNEO1FBQ0UsRUFBRSxFQUFFLFdBQVc7UUFDZixTQUFTLEVBQUUsNERBQTREO1FBQ3ZFLE9BQU8sRUFBRSxNQUFNO1FBQ2YsUUFBUSxFQUNOLDJLQUEySztLQUM5SztJQUNEO1FBQ0UsRUFBRSxFQUFFLFdBQVc7UUFDZixTQUFTLEVBQ1AsdUVBQXVFO1FBQ3pFLE9BQU8sRUFBRSxNQUFNO1FBQ2YsUUFBUSxFQUFFLGlCQUFpQjtLQUM1QjtDQUNGLENBQUMifQ==